/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Chci vědět o dostupnosti produktu`
};

const da_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg vil kende tilgængeligheden af et produkt`
};

const de_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Ich möchte die Verfügbarkeit eines Produkts wissen`
};

const en_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `I want to know the availability of a product`
};

const es_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Quiero saber la disponibilidad de un producto`
};

const fr_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Je souhaite connaître la disponibilité d'un produit`
};

const hu_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Szeretnék tudni egy termék elérhetőségéről`
};

const it_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Voglio sapere la disponibilità di un prodotto`
};

const nl_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Ik wil weten of een product beschikbaar is`
};

const pl_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Chcę poznać dostępność produktu`
};

const pt_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Quero saber a disponibilidade de um produto`
};

const sv_contact_other_subjects_product_availability = /** @type {(inputs: {}) => string} */ () => {
	return `Jag vill veta om en produkt finns i lager`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_other_subjects_product_availability = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_other_subjects_product_availability(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_other_subjects_product_availability", locale)
	if (locale === "cs") return cs_contact_other_subjects_product_availability(inputs)
	if (locale === "da") return da_contact_other_subjects_product_availability(inputs)
	if (locale === "de") return de_contact_other_subjects_product_availability(inputs)
	if (locale === "en") return en_contact_other_subjects_product_availability(inputs)
	if (locale === "es") return es_contact_other_subjects_product_availability(inputs)
	if (locale === "fr") return fr_contact_other_subjects_product_availability(inputs)
	if (locale === "hu") return hu_contact_other_subjects_product_availability(inputs)
	if (locale === "it") return it_contact_other_subjects_product_availability(inputs)
	if (locale === "nl") return nl_contact_other_subjects_product_availability(inputs)
	if (locale === "pl") return pl_contact_other_subjects_product_availability(inputs)
	if (locale === "pt") return pt_contact_other_subjects_product_availability(inputs)
	return sv_contact_other_subjects_product_availability(inputs)
};
export { contact_other_subjects_product_availability as "contact.other_subjects.product_availability" }